import React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { StyledVideo } from "core/components/Video/Video";
import ThumbnailBackground from "./ThumbnailBackground";

export default function ShortyVideoContent({
  innerVideoRef, // Ref для скрытого video элемента для preload
  content,
  showThumbnail,
  preload = false, // eslint-disable-line react/prop-types
  active = false, // eslint-disable-line react/prop-types
}) {
  const theme = useTheme();
  const isMobileView = useMediaQuery(theme.breakpoints.down("md"));

  // Для preload или неактивных видео показываем только thumbnail
  // Все контролы теперь управляются в ShortyVirtualFeed
  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
      }}
    >
      {/* Скрытый video элемент для preload/кеширования */}
      <StyledVideo
        ref={innerVideoRef}
        style={{ display: "none" }} // Скрытый для preload
        muted
        playsInline
        preload="auto"
      />
      {isMobileView ? (
        // Мобильный режим - только thumbnail и базовая информация
        <Box
          sx={{
            width: "100%",
            height: "100%",
            position: "relative",
          }}
        >
          <Box
            id="player"
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              width: "100%",
              height: "100%",
              overflow: "hidden",
              backgroundColor: "#000",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {/* Thumbnail фон */}
            {showThumbnail && (
              <ThumbnailBackground
                content={content}
                preload={preload}
                active={active}
              />
            )}
          </Box>
        </Box>
      ) : (
        // Десктоп режим - аналогично упрощенный
        <Box
          sx={{
            width: "100%",
            height: "100%",
            position: "relative",
            backgroundColor: "#000",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {/* Thumbnail фон */}
          {showThumbnail && (
            <ThumbnailBackground
              content={content}
              preload={preload}
              active={active}
            />
          )}
        </Box>
      )}
    </Box>
  );
}

ShortyVideoContent.propTypes = {
  innerVideoRef: PropTypes.object,
  content: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string,
    thumbnails: PropTypes.array,
    verticalThumbnails: PropTypes.array,
  }),
  showThumbnail: PropTypes.bool,
};
